<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-24
    	描述：财务-财务概况
    -->
  <div v-loading="loading">
    <el-form
      size="small"
      :inline="true"
      label="选择时间"
      class="demo-form-inline"
    >
      <!-- <el-form-item>
          <el-date-picker v-model="datePicker" type="datetimerange" :picker-options="pickerOptions"
            format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" align="right">
          </el-date-picker>
        </el-form-item> -->

      <el-form-item label="商户账号">
        <el-select
          size="small"
          v-model="searchForm.user_id"
          placeholder="请选择"
        >
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="(item, index) in shlist"
            :key="index"
            :label="item.name"
            :value="item.shop_supplier_id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="类型">
        <el-select size="small" v-model="searchForm.type" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="(item, index) in typeList"
            :key="index"
            :label="item.type"
            :value="item.type"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="起始时间">
        <div class="block">
          <span class="demonstration"></span>
          <el-date-picker
            size="small"
            v-model="searchForm.create_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getData"
          >查询</el-button
        >
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="info" @click="dialogVisibleYc = true"
          >预充金额</el-button
        >
      </el-form-item>

      <el-form-item>
        <el-button type="danger">消费总金额 {{ count }}</el-button>
      </el-form-item>

      <el-form-item v-if="searchForm.type">
        <el-button type="success">剩余总条数: {{ TotalPieces }}</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="ID">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="商户名称">
        <template slot-scope="scope">
          {{ scope.row.supplier ? scope.row.supplier.name : "" }}
        </template>
      </el-table-column>

      <el-table-column label="联系方式">
        <template slot-scope="scope">
          {{ scope.row.supplier ? scope.row.supplier.link_phone : "" }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.create_time }}
        </template>
      </el-table-column>

      <el-table-column label="金额(元)">
        <template slot-scope="scope">
          {{ scope.row.money }}
        </template>
      </el-table-column>

      <el-table-column label="类型">
        <template slot-scope="scope">
          {{ scope.row.type }}
        </template>
      </el-table-column>

      <!-- <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="addClick(scope.row)" size="primary">查看订单</el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, prev,sizes ,pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>

    <!-- 预充弹框 -->
    <el-dialog title="预充金额" :visible.sync="dialogVisibleYc" width="50%">
      <div class="wiabianju">
        <el-input
          placeholder="请输入金额"
          v-model="preRecharge.sirius_report_num"
        >
          <template slot="prepend">天狼星报告星耀版</template>
        </el-input>
      </div>

      <div class="wiabianju">
        <el-input
          placeholder="请输入金额"
          v-model="preRecharge.credit_report_num"
        >
          <template slot="prepend">征信报告（上报）</template>
        </el-input>
      </div>

      <div class="wiabianju">
        <el-input
          placeholder="请输入金额"
          v-model="preRecharge.bairong_risk_control_report_num"
        >
          <template slot="prepend">百融风控报告</template>
        </el-input>
      </div>

      <div class="wiabianju">
        <el-input
          placeholder="请输入金额"
          v-model="preRecharge.logistics_query_num"
        >
          <template slot="prepend">物流查询</template>
        </el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleYc = false">取 消</el-button>
        <el-button type="primary" @click="determine()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import SupplierApi from "@/api/supplier.js";
import pieChart from "@/views/home/part/product/pieChart.vue"; //引入组件
export default {
  data() {
    let endDate = new Date();
    let startDate = new Date();
    startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 7);
    return {
      dialogVisibleYc: false, // 预充弹框显示
      preRecharge: {
        risk_inquiry_num: 0, //风险查询
        sirius_report_num: null, //天狼星报告星耀版
        credit_report_num: null, //征信报告（上报）
        fraud_score_num: 0, //欺诈分
        bairong_risk_control_report_num: null, //百融风控报告
        logistics_query_num: null, //物流查询
      },
      TotalPieces: "", //总条数
      shlist: "",
      count: "",
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      datalist: "",
      /*类型列表*/
      typeList: [
        {
          type: "风险查询",
          value: 1,
        },
        {
          type: "天狼星报告星耀版",
          value: 2,
        },
        {
          type: "征信报告",
          value: 3,
        },
        {
          type: "欺诈分",
          value: 4,
        },
        {
          type: "百融风控报告",
          value: 5,
        },
        {
          type: "物流查询",
          value: 6,
        },
      ],
      searchForm: {
        user_id: "",
        type: "",
        create_time: "",
      },
      /*是否加载完成*/
      loading: true,
      /*统计数据*/
      tj_data: {},
      /*供应商数据*/
      supplier_data: {},
      /*分销商数据*/
      agent_data: {},
      rent: "",
      starttime: "",
      endtime: "",
      //时间
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      // datePicker: [formatDate(startDate, 'yyyy-MM-dd 00:00:00'), formatDate(endDate, 'yyyy-MM-dd 23:59:59')],
    };
  },
  created() {
    /*获取数据*/
    this.getTableList();
    this.getData();
  },
  components: {
    pieChart,
  },
  methods: {
    // 弹窗确定按钮
    determine() {
      let self = this;
      self.loading = true;
      console.log(self.preRecharge);
      let param = self.preRecharge;
      console.log(param);
      OrderApi.preRecharge(param, true)
        .then((res) => {
          self.$message({
            message: "操作成功",
            type: "success",
          });
          self.dialogVisibleYc = false;
          self.loading = false;
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    /*获取数据*/
    getData() {
      let self = this;
      self.loading = true;
      // let shju = {
      //   startTime: self.datePicker[0],
      //   endTime: self.datePicker[1],
      // };
      let param = {
        user_id: self.searchForm.user_id,
        type: self.searchForm.type,
        create_time: self.searchForm.create_time,
      };
      param.page = self.curPage;
      param.list_rows = self.pageSize;
      console.log('params: ', param);
      OrderApi.zhangdan(param, true)
        .then((data) => {
          // console.log("total",data.data.list.total);
          // console.log("bairong_risk_control_report_num",data.data.preRechargeList.bairong_risk_control_report_num);
          this.TotalPieces =
            data.data.preRechargeList.bairong_risk_control_report_num -
            data.data.list.total;
          // console.log(this.TotalPieces);
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.count = data.data.count.toFixed(2);
          self.$message({
            message: "加载成功",
            type: "success",
          });
          self.loading = false;
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      SupplierApi.supplierList(Params, true)
        .then((res) => {
          console.log(res.data.list.data);
          self.shlist = res.data.list.data;
          self.loading = false;
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    /*订单详情*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      let routeData = self.$router.resolve({
        path: "/order/order/Detail",
        query: {
          order_id: params,
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.wiabianju {
  margin: 20px 0;
}
.apply-container {
  padding: 50px 0;
}

.cash {
  background-color: #fff;
  font: 14px;
}

.cash_t_common {
  margin-top: 15px;
  margin-bottom: 0;
  box-shadow: initial;

  .cash_t_title {
    font-size: 16px;
    font-weight: 600;
  }

  .cash-header {
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.cash_t_brief .cash-header {
  border-bottom: 0;
  padding-bottom: 0;
}

.cash-header {
  position: relative;
  height: 42px;
  line-height: 42px;
  padding: 0 15px;
  border-bottom: 1px solid #f6f6f6;
  color: #333;
  border-radius: 2px 2px 0 0;
  font-size: 14px;
}

.cash_t_brief .cash_t_title {
  position: relative;
  padding-left: 10px;
}

.cash_t_brief .cash_t_title::before {
  content: "";
  display: inline-block;
  width: 3px;
  height: 14px;
  background-color: #3a8ee6;
  position: absolute;
  left: 0;
  top: 50%;
  border-radius: 5px;
  transform: translateY(-50%);
}

.cash_t_common .cash-body {
  padding: 20px;
}

.cash-body {
  display: flex;
  justify-content: flex-start;
  padding-bottom: 0 !important;
  padding-right: 50px !important;
  padding-left: 50px !important;
  flex-wrap: wrap;
  position: relative;
  padding: 10px 15px;
  line-height: 24px;

  .content {
    width: 33.3%;
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    justify-content: center;
  }

  .content {
    width: 33.3%;
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    justify-content: center;
  }

  .money {
    font-size: 20px;
    color: #666;
    font-weight: bold;
    margin-top: 10px;
    max-width: 250px;
  }

  .subhead {
    font-size: 12px;
    margin-left: 3px;
    cursor: pointer;
  }
}

.ns-text-color {
  color: #3a8ee6;
}

.date_section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/cash/cash/zhangdan.vue